<template>
  <div>
    <div class="bg-body"/>
    <div>
      <div class="messages-head-bg"/>
      <div class="messages-head-previous" @click="previous">
        <div><img src="@/assets/img/messages/previous.png"></div>
        <div>Messages</div>
      </div>
      <div class="col-md-12 file-head-content">
        <div class="file-header">
          <div class="col-10">
            <div class="file-header-title">Référent handicap</div>
          </div>
          <div class="col-2 file-header-logo"><img src="@/assets/img/logo.png"></div>
        </div>
      </div>
    </div>

    <div class="messages-info">
      <div class="messages-info-content">
        <div class="messages-info-header">
          <div class="messages-info-header-icon "><img src="@/assets/img/messages/handicap.png"></div>
          <div class="messages-info-header-label">Contact</div>
        </div>

        <div class="messages-info-bravo">{{ campus }}</div>
        <div class="messages-info-charlie">{{ referentHandicap }}</div>
        <div class="messages-info-charlie">{{ referentHandicapPhone }}</div>
        <div class="messages-info-charlie">{{ referentHandicapMail }}</div>
      </div>
    </div>

    <div class="form-group">
      <button class="btn btn-primary btn-block" @click="actionMail">
        <span class="messages-group-menu-icon-right "><img src="@/assets/img/navbar/message.png" alt="Écrire au référent"/>{{ referentHandicapMail }}</span>
      </button>
    </div>

    <div class="form-group" v-if="referentHandicapPhone !== '' && referentHandicapPhone !== null">
      <button class="btn btn-white btn-block" @click="actionPhone">
        <span class="messages-group-menu-icon-right "><img src="@/assets/img/messages/phone.png" alt="Appeler {{ referentHandicapPhone }}"/>{{ referentHandicapPhone }}</span>
      </button>
    </div>


  </div>
</template>

<script>

import UserService from "@/services/user.service";

export default {
  name: "MessagesHandicap",
  data() {
    return {
      campus: null,
      referentHandicap: null,
      referentHandicapPhone: null,
      referentHandicapMail: null,
    }
  },
  mounted() {
    UserService.getDashboardContent("MessagesHandicap").then(
        (response) => {
          this.campus = response.data.campus
          this.referentHandicapPhone = response.data.referentHandicapPhone
          this.referentHandicapMail = response.data.referentHandicapMail
          this.referentHandicap = response.data.referentHandicap
        },
        (error) => {
          this.content =
              (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
              error.message ||
              error.toString();
        }
    );
  },
  methods: {
    actionMail: function () {
      window.location.href = "mailto:" + this.referentHandicapMail;
    },
    actionPhone: function () {
      window.location.href = "tel:" + this.referentHandicapPhone;
    },
    previous: function () {
      this.$router.push({name: 'messages'});
    }
  }
};
</script>
